import { getResolvedPackageName } from './packageIdentity'

/**
 * App → H5 公参白名单。
 * 第一期只有 packageName；后续扩展 channel / appVersion 等时只改这里。
 * pt 在启动时换算成 packageName，不要放进这个白名单。
 */
export const APP_COMMON_PARAM_KEYS = ['packageName'] as const

export type AppCommonParamKey = (typeof APP_COMMON_PARAM_KEYS)[number]

/** 白名单公参。packageName 用本次解析结果，其它键仍读 localStorage。 */
export function pickAppCommonParams(
  storage: Storage = localStorage
): Record<string, string> {
  return APP_COMMON_PARAM_KEYS.reduce<Record<string, string>>((ret, key) => {
    const value = key === 'packageName' ? getResolvedPackageName() : storage.getItem(key)
    if (value) {
      ret[key] = value
    }
    return ret
  }, {})
}
